import { RuntimeProps } from "views";

const md5 = require("md5-node");

enum ConfigKey {
	AppKey = "app_key",
	AppSecret = "app_secret",
}

export const transformSign = (param: Partial<RuntimeProps>): string => {
	const { appKey = "", appSecret = "" } = param;
	const sign = ConfigKey.AppKey + appKey + ConfigKey.AppSecret + appSecret;
	return md5(sign);
};